import { formatSpendAmount, formatSpendTotal } from "@/lib/ai/spend-format";
import type { AiSpendCurrency } from "@/lib/ai/spend-cost";

export const platformCopy = {
  brand: "Платформа",
  loginTitle: "Вход в платформу",
  loginDescription: "Для тех, кто создаёт и ведёт тенантов PinWiki.",
  submit: "Войти",
  pending: "Входим…",
  errorTitle: "Ошибка входа",
  logout: "Выйти",
  title: "Тенанты",
  description: "Список тенантов сервиса. Сотрудники входят в свой тенант отдельно.",
  crumbs: "Платформа",
  navHome: "Главная",
  navTenants: "Тенанты",
  navUsers: "Пользователи",
  navChannels: "Каналы",
  navAnalytics: "Аналитика",
  navOps: "Мониторинг",
  navAi: "AI",
  navPackages: "Пакеты знаний",
  homeTitle: "Главная",
  homeDescription: "Виджеты платформы: расход AI и балансы провайдеров.",
  tenantsTitle: "Тенанты",
  tenantsDescription:
    "Список тенантов сервиса. Сотрудники входят в свой тенант отдельно.",
  channelsTitle: "Каналы",
  channelsDescription:
    "Контакты мессенджеров по тенантам и аудиториям. Справа — до шести лент сразу.",
  channelsFilterTenant: "Тенант",
  channelsFilterAudience: "Аудитория",
  channelsFilterAll: "Все",
  channelsNoAudience: "Без аудитории",
  channelsEmptyTitle: "Нет контактов",
  channelsEmptyDescription: "Появятся, когда кто-то напишет боту тенанта.",
  channelsEmptyFilterTitle: "Никого нет",
  channelsEmptyFilterDescription: "Смените тенант или аудиторию.",
  channelsPickTitle: "Выберите чаты",
  channelsPickDescription: "В списке слева можно открыть до шести лент.",
  channelsEmptyChatTitle: "Пока нет сообщений",
  channelsEmptyChatDescription:
    "Лента появится, если у тенанта включено сохранение переписок.",
  channelsMore: "Ещё раньше",
  channelsPoll: "Опрос",
  channelsPoll5: "5 с",
  channelsPoll30: "30 с",
  channelsCloseChat: "Закрыть чат",
  channelsMaxOpen: "Открыто 6 чатов — сначала закройте один.",
  channelsAudit: "Аудит",
  auditTitle: "Аудит",
  auditDocumentsTitle: "Документы канала",
  auditDocumentsHelp:
    "Файлы, которые этот контакт видит в мессенджере, и право, по которому открыт доступ.",
  auditMembersTitle: "Аудитория канала",
  auditMembersHelp:
    "Контакты тех же аудиторий, что и этот чат. Сотрудник — если контакт связан с учётной записью тенанта.",
  auditColumnDocument: "Документ",
  auditColumnAccess: "Доступ",
  auditColumnDepartment: "Отдел",
  auditColumnOwner: "Владелец",
  auditColumnVersion: "Версия",
  auditColumnDate: "Дата",
  auditColumnIndex: "Индекс",
  auditColumnName: "Имя",
  auditColumnChannel: "Канал",
  auditColumnKind: "Кто",
  auditColumnAudiences: "Аудитории",
  auditColumnRoles: "Роли",
  auditKindContact: "Контакт",
  auditKindEmployee: "Сотрудник",
  auditThisChat: "этот чат",
  auditEmptyDocumentsTitle: "Нет доступных документов",
  auditEmptyDocumentsDescription:
    "У этого канала нет чтения ни по одному файлу.",
  auditEmptyMembersTitle: "В аудитории никого нет",
  auditEmptyMembersDescription:
    "Контакт не состоит в аудитории — список появится после назначения.",
  auditAdminAccess: "Администратор",
  auditNoAudience: "без аудитории",
  auditLinkedEmployee: "Сотрудник",
  analyticsTitle: "Аналитика",
  analyticsDescription:
    "Платежи, услуги и расход провайдеров за выбранный период.",
  analyticsPaymentsTab: "Платежи",
  analyticsServicesTab: "Услуги",
  analyticsProvidersTab: "Провайдеры",
  analyticsEmptyTenantsTitle: "Пока нет отчёта",
  analyticsEmptyTenantsDescription:
    "За выбранный период нет платежей и услуг.",
  analyticsEmptyProvidersTitle: "Пока нет отчёта",
  analyticsEmptyProvidersDescription:
    "За выбранный период нет расхода провайдеров.",
  analyticsFilterRange: "Период",
  analyticsFilterFrom: "С",
  analyticsFilterTo: "По",
  analyticsFilterCostObject: "Объект затрат",
  analyticsFilterService: "Услуга",
  analyticsFilterProvider: "Провайдер",
  analyticsFilterModel: "Модель",
  analyticsFilterThinking: "Thinking",
  analyticsFilterAll: "Все",
  analyticsFilterTenant: "Тенант",
  analyticsFilterAllTenants: "Все",
  thinkingOff: "Выкл",
  analyticsTotal: "Итого",
  kpiInflow: "Поступления",
  kpiSpend: "Расходы",
  kpiBalance: "Баланс",
  analyticsExport: "Экспорт",
  analyticsExportCsv: "CSV",
  analyticsExportXlsx: "XLSX",
  columnCostObject: "Объект затрат",
  analyticsPaymentsTitle: "Платежи",
  columnTenant: "Тенант",
  columnProvider: "Провайдер",
  columnModel: "Модель",
  columnThinking: "Thinking",
  thinkingOn: "Вкл",
  columnOperations: "Операции",
  providerOpenRouter: "OpenRouter",
  providerTimeweb: "Timeweb",
  providerOllama: "Ollama",
  opsTitle: "Мониторинг",
  opsDescription:
    "Здоровье сервиса, очередь разбора, журнал событий и заявки с лендинга. Текст документов тенантов здесь не показывается.",
  opsHealthTab: "Здоровье",
  opsJobsTab: "Очередь",
  opsJournalTab: "Журнал",
  opsWaitlistTab: "Заявки",
  opsBotsTab: "Боты",
  opsHealthOk: "Все проверки прошли.",
  opsHealthDegraded: "Есть сбои — разбор, поиск или заявки могут быть недоступны.",
  opsPulseHelp: "Активность за последние 24 часа. Текст документов и сообщений не показываем.",
  opsPulseTenants: "Активные тенанты",
  opsPulseChats: "Чаты",
  opsPulseBots: "Сообщения ботов",
  opsPulseIndexed: "В индексе",
  opsPulseWalletEmpty: "Нулевой кошелёк",
  opsCheckApp: "Приложение",
  opsCheckDatabase: "База данных",
  opsCheckQdrant: "Поиск",
  opsCheckStorage: "Файлы",
  opsCheckWorker: "Очередь работ",
  opsCheckOk: "В порядке",
  opsCheckError: "Сбой",
  opsCheckSkip: "Не настроен",
  opsCheckAppOk: "Консоль отвечает.",
  opsCheckDatabaseOk: "PostgreSQL отвечает.",
  opsCheckDatabaseError: "PostgreSQL недоступна.",
  opsCheckQdrantOk: "Qdrant отвечает.",
  opsCheckQdrantError: "Поиск по смыслу недоступен.",
  opsCheckQdrantSkip: "Qdrant не настроен.",
  opsCheckStorageOk: "Каталог файлов доступен.",
  opsCheckStorageError: "Каталог файлов недоступен.",
  opsCheckWorkerOk: "Очередь не застряла.",
  opsCheckWorkerError: "Очередь разбора не двигается.",
  opsCheckOpenRouter: "OpenRouter",
  opsCheckTimeweb: "Timeweb",
  opsCheckOllama: "Ollama",
  opsCheckOpenRouterOk: "Баланс читается.",
  opsCheckOpenRouterError: "Не удалось проверить баланс OpenRouter.",
  opsCheckOpenRouterSkip: "Ключ OpenRouter не задан.",
  opsCheckTimewebOk: "Баланс читается.",
  opsCheckTimewebError: "Не удалось проверить баланс Timeweb.",
  opsCheckTimewebSkip: "Токен Timeweb не задан.",
  opsCheckOllamaOk: "Ollama отвечает.",
  opsCheckOllamaError: "Ollama недоступна.",
  opsCheckOllamaSkip: "Адрес Ollama не задан.",
  opsJobKindIndex: "Разбор файла",
  opsJobKindChannel: "Ответ бота",
  opsJobKindExtract: "Wiki",
  opsJobPending: "В очереди",
  opsJobProcessing: "В работе",
  opsJobFailed: "Ошибка",
  opsJobStale: "Застряла",
  opsColumnKind: "Тип",
  opsColumnSubject: "Файл или контакт",
  opsColumnStatus: "Состояние",
  opsColumnError: "Ошибка",
  opsJobInternalError: "Внутренняя ошибка, сообщение не ушло",
  opsJobQuotaError: "Лимит ключа провайдера исчерпан",
  opsJobsHelp:
    "Незавершённый разбор файлов, извлечение Wiki и ответы ботов. Текст документов и сообщений не показываем.",
  opsJobsEmptyTitle: "Очередь пуста",
  opsJobsEmptyDescription:
    "Строка появится, если застрял разбор файла, извлечение Wiki или ответ бота.",
  opsJobsSearchLabel: "Найти работу",
  opsJobsSearchPlaceholder: "Тенант или объект",
  opsJournalHelp:
    "Сбои разбора, Wiki и ботов и заявки с лендинга. Пишем по мере события. Текст документов и сообщений не показываем.",
  opsJournalEmptyTitle: "Записей нет",
  opsJournalEmptyDescription:
    "Появятся после сбоя или новой заявки за выбранный период.",
  opsJournalFilterCategory: "Категория",
  opsJournalFilterSeverity: "Критичность",
  opsJournalCategoryBot: "Бот",
  opsJournalCategoryTenant: "Тенант",
  opsJournalNoTenant: "—",
  opsJournalStaleMessage: "Работа не двигается.",
  opsJournalWaitlistMessage: "Заявка с лендинга",
  opsJournalSuspendMessage: "Тенант приостановлен",
  opsJournalActivateMessage: "Тенант включён",
  opsSeverityError: "Ошибка",
  opsSeverityWarning: "Предупреждение",
  opsSeverityInfo: "Информация",
  opsColumnCategory: "Категория",
  opsColumnSeverity: "Критичность",
  opsColumnObject: "Объект",
  opsColumnMessage: "Сообщение",
  opsBotsHelp:
    "Подключённые Telegram и MAX: последний входящий и ошибка ответа. Текст переписки не показываем.",
  opsBotsEmptyTitle: "Ботов нет",
  opsBotsEmptyDescription:
    "Появятся, когда тенант подключит Telegram или MAX.",
  opsBotsSearchLabel: "Найти бота",
  opsBotsSearchPlaceholder: "Тенант или имя бота",
  opsBotOff: "Выкл",
  opsBotIdle: "Ждёт сообщений",
  opsBotOk: "В порядке",
  opsColumnBot: "Бот",
  opsWaitlistSearchLabel: "Найти заявку",
  opsWaitlistSearchPlaceholder: "Имя, почта или компания",
  opsWaitlistEmptyTitle: "Заявок пока нет",
  opsWaitlistEmptyDescription: "Появятся, когда кто-то оставит форму на лендинге.",
  opsWaitlistEmptyFilterTitle: "Никого нет",
  opsWaitlistEmptyFilterDescription: "Измените запрос.",
  opsColumnCompany: "Компания",
  opsColumnDeployment: "Развёртывание",
  opsColumnEmail: "Email",
  aiTitle: "AI",
  aiDescription:
    "Провайдер, ключи и модели для всех тенантов. Эмбеддинги по-прежнему идут через Ollama.",
  create: "Создать тенант",
  createTitle: "Новый тенант",
  cancel: "Отмена",
  pendingSave: "Сохраняем…",
  nameLabel: "Название",
  slugLabel: "Идентификатор",
  slugHelp: "Латиница, цифры и дефис. Потом не меняется.",
  adminNameLabel: "Администратор",
  adminEmailLabel: "Email администратора",
  adminPasswordLabel: "Пароль администратора",
  invalidName: "Укажите название",
  invalidSlug: "Идентификатор: латиница, цифры и дефис, от 2 до 40 знаков",
  invalidAdminName: "Укажите имя администратора",
  invalidEmail: "Укажите корректный email",
  invalidPassword: "Пароль не короче 8 символов",
  slugTaken: "Тенант с таким идентификатором уже есть",
  emailTaken: "Пользователь с таким email уже есть",
  denied: "Нужно войти как администратор платформы",
  columnName: "Название",
  columnSlug: "Идентификатор",
  columnUsers: "Сотрудники",
  columnUsd: "USD",
  columnRub: "RUB",
  columnSpend: "Расход",
  columnCreated: "Создан",
  open: "Открыть",
  searchLabel: "Найти тенанта",
  searchPlaceholder: "Название или идентификатор",
  emptyTitle: "Пока нет тенантов",
  emptyDescription: "Создайте первого тенанта — его администратор сможет войти в PinWiki.",
  emptyFilterTitle: "Ничего не найдено",
  emptyFilterDescription: "Измените запрос.",
  walletTitle: "Баланс AI",
  walletDescription:
    "С этого счёта списываются ответы чата и извлечение Wiki. Пока сумму не зачислили, лимита нет.",
  walletIdle: "Счёт не открыт",
  walletCredit: "Зачислить",
  walletDebit: "Списать",
  walletAmount: "Сумма",
  walletComment: "Комментарий",
  walletCommentHelp: "Зачем зачислили или списали. Необязательно.",
  walletCurrency: "Валюта",
  walletKind: "Операция",
  walletSubmit: "Провести",
  walletSaved: "Баланс обновлён",
  ledgerTitle: "Журнал",
  ledgerEmptyTitle: "Пока нет операций",
  ledgerEmptyDescription: "Зачисление и списание появятся здесь.",
  servicesTitle: "Услуги",
  servicesHelp: "Чат и индексация этого тенанта. Списание с его бюджета.",
  servicesEmptyTitle: "Пока нет списаний",
  servicesEmptyDescription: "Чат и индексация появятся здесь.",
  columnService: "Услуга",
  serviceChat: "Чат",
  serviceIndex: "Индексация",
  whoSystem: "Система",
  whoMessenger: "Мессенджер",
  columnKind: "Операция",
  columnAmount: "Сумма",
  columnComment: "Комментарий",
  columnWho: "Кто",
  columnWhen: "Когда",
  columnDate: "Дата",
  columnTime: "Время",
  kindCredit: "Зачисление",
  kindDebit: "Списание",
  invalidAmount: "Сумма: число больше нуля, не больше двух знаков после точки",
  invalidCurrency: "Выберите валюту",
  invalidKind: "Выберите зачисление или списание",
  debitWithoutAccount: "Сначала зачислите сумму — счёт ещё не открыт",
  debitTooMuch: "Нельзя списать больше остатка",
  missingTenant: "Тенант не найден",
  tenantCreditsTab: "Зачисления",
  tenantSpendTab: "Расходы",
  tenantOwnerTab: "Владелец",
  tenantAccessTab: "Доступ",
  tenantPackagesTab: "Пакеты",
  tenantAccessHelp:
    "Выдачи и отзывы доступа. Имена файлов и коллекций, без текста.",
  tenantAccessEmptyTitle: "Записей нет",
  tenantAccessEmptyDescription:
    "Появятся после выдачи или отзыва доступа в этом тенанте.",
  accessColumnAction: "Действие",
  accessColumnWhom: "Кому",
  accessColumnPermission: "Право",
  accessTargetDocument: "Файл",
  accessTargetCollection: "Коллекция",
  tenantStatusColumn: "Состояние",
  tenantStatusActive: "Работает",
  tenantStatusSuspended: "Приостановлен",
  tenantSuspend: "Приостановить",
  tenantActivate: "Включить",
  tenantSuspendTitle: "Приостановить тенанта?",
  tenantActivateTitle: "Включить тенанта?",
  tenantSuspendHelp:
    "Сотрудники не войдут, боты не ответят, пока не включите снова.",
  tenantActivateHelp: "Сотрудники и боты снова смогут работать.",
  tenantSuspendedLogin: "Организация приостановлена.",
  userBlockedLogin: "Учётная запись заблокирована.",
  ownerAdminsTitle: "Администраторы",
  ownerAdminsHelp:
    "Входят в тенант как администраторы организации. Можно добавить ещё или сменить пароль.",
  ownerAddAdmin: "Добавить администратора",
  ownerAddAdminTitle: "Новый администратор",
  ownerAdminCreated: "Администратор добавлен",
  ownerPassword: "Сменить пароль",
  ownerPasswordTitle: "Новый пароль",
  ownerPasswordSaved: "Пароль обновлён",
  ownerEmptyTitle: "Нет администраторов",
  ownerEmptyDescription: "Добавьте администратора, чтобы войти в этот тенант.",
  missingAdmin: "Администратор не найден",
  invalidComment: "Комментарий не длиннее 200 знаков",
} as const;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const SLUG_RE = /^[a-z][a-z0-9-]{1,39}$/;
const MIN_PASSWORD_LENGTH = 8;

export type CreateTenantInput = {
  name: string;
  slug: string;
  adminName: string;
  adminEmail: string;
  adminPassword: string;
};

export function isPlatformPath(pathname: string): boolean {
  return pathname === "/platform" || pathname.startsWith("/platform/");
}

export function parseTenantSlug(raw: string): string | null {
  const slug = raw.trim().toLowerCase();
  return SLUG_RE.test(slug) ? slug : null;
}

export function parseCreateTenantInput(input: {
  name: string;
  slug: string;
  adminName: string;
  adminEmail: string;
  adminPassword: string;
}): { ok: true; value: CreateTenantInput } | { ok: false; error: string } {
  const name = input.name.trim();
  const slug = parseTenantSlug(input.slug);
  const adminName = input.adminName.trim();
  const adminEmail = input.adminEmail.trim().toLowerCase();
  const adminPassword = input.adminPassword;

  if (!name) {
    return { ok: false, error: platformCopy.invalidName };
  }
  if (!slug) {
    return { ok: false, error: platformCopy.invalidSlug };
  }
  if (!adminName) {
    return { ok: false, error: platformCopy.invalidAdminName };
  }
  if (!adminEmail || !EMAIL_RE.test(adminEmail)) {
    return { ok: false, error: platformCopy.invalidEmail };
  }
  if (adminPassword.length < MIN_PASSWORD_LENGTH) {
    return { ok: false, error: platformCopy.invalidPassword };
  }

  return {
    ok: true,
    value: { name, slug, adminName, adminEmail, adminPassword },
  };
}

export type TenantAdminInput = {
  name: string;
  email: string;
  password: string;
};

export function parseTenantAdminInput(input: {
  name: string;
  email: string;
  password: string;
}): { ok: true; value: TenantAdminInput } | { ok: false; error: string } {
  const name = input.name.trim();
  const email = input.email.trim().toLowerCase();
  const password = input.password;
  if (!name) {
    return { ok: false, error: platformCopy.invalidAdminName };
  }
  if (!email || !EMAIL_RE.test(email)) {
    return { ok: false, error: platformCopy.invalidEmail };
  }
  if (password.length < MIN_PASSWORD_LENGTH) {
    return { ok: false, error: platformCopy.invalidPassword };
  }
  return { ok: true, value: { name, email, password } };
}

export function parseTenantAdminPassword(
  raw: string,
): { ok: true; value: string } | { ok: false; error: string } {
  if (raw.length < MIN_PASSWORD_LENGTH) {
    return { ok: false, error: platformCopy.invalidPassword };
  }
  return { ok: true, value: raw };
}

export function filterPlatformTenants<T extends { name: string; slug: string }>(
  rows: T[],
  query: string,
): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return rows;
  }
  return rows.filter(
    (row) =>
      row.name.toLowerCase().includes(needle) ||
      row.slug.toLowerCase().includes(needle),
  );
}

export function tenantStatusLabel(suspendedAt: Date | null | undefined): string {
  return suspendedAt
    ? platformCopy.tenantStatusSuspended
    : platformCopy.tenantStatusActive;
}

export function tenantStatusTagType(suspended: boolean): "green" | "red" {
  return suspended ? "red" : "green";
}

export function platformTenantHref(id: string): string {
  return `/platform/tenants/${id}`;
}

export function platformTenantSpendHref(id: string): string {
  return `/platform/tenants/${id}/spend`;
}

export function platformTenantOwnerHref(id: string): string {
  return `/platform/tenants/${id}/owner`;
}

export function platformTenantAccessHref(id: string): string {
  return `/platform/tenants/${id}/access`;
}

export function platformTenantPackagesHref(id: string): string {
  return `/platform/tenants/${id}/packages`;
}

export function platformTenantAuditHref(tenantId: string, contactId: string): string {
  return `/platform/tenants/${tenantId}/audit/${contactId}`;
}

export function platformAiHref(): string {
  return "/platform/ai";
}

export function platformPackagesHref(): string {
  return "/platform/packages";
}

export function platformPackageHref(id: string): string {
  return `/platform/packages/${id}`;
}

export function platformPackageContentHref(id: string): string {
  return `/platform/packages/${id}/content`;
}

export function platformPackageJournalHref(id: string): string {
  return `/platform/packages/${id}/journal`;
}

export function platformPackageWikiHref(
  id: string,
  claimId?: string,
): string {
  const base = `/platform/packages/${id}/wiki`;
  if (!claimId) {
    return base;
  }
  return `${base}?id=${encodeURIComponent(claimId)}`;
}

export function platformPackageWikiClaimEditsHref(
  packageId: string,
  claimId: string,
): string {
  return `/platform/packages/${packageId}/wiki/claims/${claimId}/edits`;
}

export function platformPackageReleasesHref(id: string): string {
  return `/platform/packages/${id}/releases`;
}

export function platformPackageTenantsHref(id: string): string {
  return `/platform/packages/${id}/tenants`;
}

export function platformPackageDocumentHref(
  packageId: string,
  documentId: string,
): string {
  return `/platform/packages/${packageId}/documents/${documentId}`;
}

export function platformPackageDocumentFileHref(
  packageId: string,
  documentId: string,
): string {
  return `/platform/packages/${packageId}/documents/${documentId}/file`;
}

export function platformOpsHref(): string {
  return "/platform/ops";
}

export function platformOpsJobsHref(): string {
  return "/platform/ops/jobs";
}

export type PlatformOpsJournalQuery = {
  from?: string;
  to?: string;
  tenant?: string | null;
  category?: string | null;
  severity?: string | null;
};

function journalSearch(query?: PlatformOpsJournalQuery): string {
  const params = new URLSearchParams();
  if (query?.from) {
    params.set("from", query.from);
  }
  if (query?.to) {
    params.set("to", query.to);
  }
  if (query?.tenant) {
    params.set("tenant", query.tenant);
  }
  if (query?.category) {
    params.set("category", query.category);
  }
  if (query?.severity) {
    params.set("severity", query.severity);
  }
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export function platformOpsJournalHref(query?: PlatformOpsJournalQuery): string {
  return `/platform/ops/journal${journalSearch(query)}`;
}

export function platformOpsBotsHref(): string {
  return "/platform/ops/bots";
}

export function platformOpsWaitlistHref(): string {
  return "/platform/ops/waitlist";
}

export function platformHref(): string {
  return "/platform";
}

export function platformNavItems(): { href: string; label: string }[] {
  return [
    { href: platformHref(), label: platformCopy.navHome },
    { href: platformTenantsHref(), label: platformCopy.navTenants },
    { href: platformUsersHref(), label: platformCopy.navUsers },
    { href: platformChannelsHref(), label: platformCopy.navChannels },
    { href: platformAnalyticsHref(), label: platformCopy.navAnalytics },
    { href: platformOpsHref(), label: platformCopy.navOps },
    { href: platformPackagesHref(), label: platformCopy.navPackages },
    { href: platformAiHref(), label: platformCopy.navAi },
  ];
}

export function isPlatformNavCurrent(pathname: string, href: string): boolean {
  if (href === platformHref()) {
    return pathname === href;
  }
  return pathname === href || pathname.startsWith(`${href}/`);
}

export function platformTenantsHref(): string {
  return "/platform/tenants";
}

export function platformUsersHref(): string {
  return "/platform/users";
}

export function platformUserHref(id: string): string {
  return `/platform/users/${id}`;
}

export function platformUserActivityHref(id: string): string {
  return `/platform/users/${id}/activity`;
}

export function platformChannelsHref(): string {
  return "/platform/channels";
}

export type PlatformAnalyticsQuery = {
  from?: string;
  to?: string;
  tenant?: string | null;
  service?: string | null;
  provider?: string | null;
  model?: string | null;
  thinking?: string | null;
  who?: string | null;
};

function analyticsSearch(query?: PlatformAnalyticsQuery): string {
  const params = new URLSearchParams();
  if (query?.from) {
    params.set("from", query.from);
  }
  if (query?.to) {
    params.set("to", query.to);
  }
  if (query?.tenant) {
    params.set("tenant", query.tenant);
  }
  if (query?.service) {
    params.set("service", query.service);
  }
  if (query?.provider) {
    params.set("provider", query.provider);
  }
  if (query?.model) {
    params.set("model", query.model);
  }
  if (query?.thinking) {
    params.set("thinking", query.thinking);
  }
  if (query?.who) {
    params.set("who", query.who);
  }
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export function platformAnalyticsHref(query?: PlatformAnalyticsQuery): string {
  return `/platform/analytics${analyticsSearch(query)}`;
}

export function platformAnalyticsServicesHref(
  query?: PlatformAnalyticsQuery,
): string {
  return `/platform/analytics/services${analyticsSearch(query)}`;
}

export function platformAnalyticsProvidersHref(
  query?: PlatformAnalyticsQuery,
): string {
  return `/platform/analytics/providers${analyticsSearch(query)}`;
}

const MAX_WALLET_AMOUNT = 100_000;
const MAX_COMMENT = 200;

export type WalletKind = "CREDIT" | "DEBIT";
export type WalletCurrency = "USD" | "RUB";

export type ManualWalletInput = {
  kind: WalletKind;
  currency: WalletCurrency;
  amount: number;
  comment: string | null;
};

export function parseWalletKind(raw: string): WalletKind | null {
  return raw === "CREDIT" || raw === "DEBIT" ? raw : null;
}

export function parseWalletCurrency(raw: string): WalletCurrency | null {
  return raw === "USD" || raw === "RUB" ? raw : null;
}

export function parseWalletAmount(raw: string): number | null {
  const trimmed = raw.trim().replace(",", ".");
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
    return null;
  }
  const value = Number(trimmed);
  if (!Number.isFinite(value) || value <= 0 || value > MAX_WALLET_AMOUNT) {
    return null;
  }
  return value;
}

export function parseManualWalletInput(input: {
  kind: string;
  currency: string;
  amount: string;
  comment: string;
}): { ok: true; value: ManualWalletInput } | { ok: false; error: string } {
  const kind = parseWalletKind(input.kind);
  const currency = parseWalletCurrency(input.currency);
  const amount = parseWalletAmount(input.amount);
  const comment = input.comment.trim();

  if (!kind) {
    return { ok: false, error: platformCopy.invalidKind };
  }
  if (!currency) {
    return { ok: false, error: platformCopy.invalidCurrency };
  }
  if (amount == null) {
    return { ok: false, error: platformCopy.invalidAmount };
  }
  if (comment.length > MAX_COMMENT) {
    return { ok: false, error: platformCopy.invalidComment };
  }

  return {
    ok: true,
    value: {
      kind,
      currency,
      amount,
      comment: comment || null,
    },
  };
}

export function nextWalletBalance(
  current: number | null,
  kind: WalletKind,
  amount: number,
): { ok: true; value: number } | { ok: false; error: string } {
  if (kind === "CREDIT") {
    return { ok: true, value: (current ?? 0) + amount };
  }
  if (current == null) {
    return { ok: false, error: platformCopy.debitWithoutAccount };
  }
  if (amount > current) {
    return { ok: false, error: platformCopy.debitTooMuch };
  }
  return { ok: true, value: current - amount };
}

export function formatWalletBalance(
  value: number | null | undefined,
  currency: AiSpendCurrency,
): string {
  if (value == null) {
    return "—";
  }
  return formatSpendAmount(value, currency);
}

export function formatTenantListSpend(usd: number, rub: number): string {
  if (!(usd > 0) && !(rub > 0)) {
    return "—";
  }
  return formatSpendTotal(usd, rub);
}

export function walletAmountLabel(
  kind: WalletKind,
  amount: number,
  currency: string,
): string {
  const signed = kind === "DEBIT" ? -amount : amount;
  return formatWalletBalance(signed, parseWalletCurrency(currency) ?? "USD");
}
